import { render, staticRenderFns } from "./BrandResources.vue?vue&type=template&id=09e17552&"
import script from "./BrandResources.vue?vue&type=script&lang=ts&"
export * from "./BrandResources.vue?vue&type=script&lang=ts&"
import style0 from "./BrandResources.vue?vue&type=style&index=0&id=09e17552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports